export default function Process() {
  const steps = [
    {
      number: '01',
      title: 'Diagnóstico de tu Perfil',
      description: 'Analizamos en detalle tu situación crediticia actual, historial, scores y capacidad de aprobación para diseñar la mejor estrategia.',
      icon: 'ri-search-line'
    },
    {
      number: '02',
      title: 'Plan de Optimización',
      description: 'Creamos un plan personalizado para optimizar tu perfil crediticio antes de las aplicaciones, maximizando tus probabilidades de éxito.',
      icon: 'ri-file-list-line'
    },
    {
      number: '03',
      title: 'Rondas Estratégicas de Aplicaciones',
      description: 'Ejecutamos aplicaciones en momentos estratégicos y con los productos adecuados, siguiendo un timing perfecto para mejores resultados.',
      icon: 'ri-send-plane-line'
    },
    {
      number: '04',
      title: 'Obtención de Capital',
      description: 'Conseguimos tarjetas personales y de negocio con 0% APR promocional, líneas de crédito y productos bancarios estratégicos.',
      icon: 'ri-bank-card-2-line'
    },
    {
      number: '05',
      title: 'Acompañamiento Continuo',
      description: 'Te guiamos en el uso inteligente del capital obtenido, estrategias de pago y cómo mantener tu perfil en óptimas condiciones.',
      icon: 'ri-user-follow-line'
    }
  ];

  return (
    <section className="py-24 bg-[#050505] relative overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-[#D4AF37]/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-[#D4AF37]/5 rounded-full blur-3xl"></div>
      </div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Nuestro <span className="text-[#D4AF37]">Proceso</span>
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Un método probado paso a paso para conseguir el capital que necesitas
          </p>
          <div className="w-24 h-1 bg-[#D4AF37] mx-auto mt-6"></div>
        </div>

        <div className="relative">
          {/* Línea de conexión vertical en móvil, horizontal en desktop */}
          <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-[#D4AF37]/30 to-transparent transform -translate-y-1/2"></div>
          
          <div className="grid lg:grid-cols-5 gap-8">
            {steps.map((step, index) => (
              <div key={index} className="relative">
                {/* Línea conectora en móvil */}
                {index < steps.length - 1 && (
                  <div className="lg:hidden absolute left-8 top-20 bottom-0 w-0.5 bg-[#D4AF37]/30 transform translate-y-8"></div>
                )}
                
                <div className="relative bg-[#1C1C1C] p-6 rounded-xl border border-[#D4AF37]/20 hover:border-[#D4AF37] transition-all duration-300 hover:transform hover:scale-105 h-full">
                  {/* Número del paso */}
                  <div className="absolute -top-4 -left-4 w-16 h-16 bg-gradient-to-br from-[#D4AF37] to-[#F4D03F] rounded-full flex items-center justify-center shadow-lg shadow-[#D4AF37]/50">
                    <span className="text-[#050505] font-bold text-lg">{step.number}</span>
                  </div>

                  {/* Icono */}
                  <div className="w-12 h-12 bg-[#D4AF37]/10 rounded-lg flex items-center justify-center mb-4 mt-6">
                    <i className={`${step.icon} text-[#D4AF37] text-xl`}></i>
                  </div>

                  {/* Contenido */}
                  <h3 className="text-lg font-bold text-white mb-3 leading-tight">
                    {step.title}
                  </h3>
                  <p className="text-gray-400 text-sm leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA al final del proceso */}
        <div className="mt-16 text-center">
          <div className="inline-block bg-[#1C1C1C] px-8 py-6 rounded-2xl border border-[#D4AF37]/30">
            <p className="text-gray-300 text-lg mb-4">
              <i className="ri-time-line text-[#D4AF37] mr-2"></i>
              <strong className="text-white">Tiempo estimado:</strong> Los resultados pueden verse desde las primeras semanas, dependiendo de tu perfil inicial
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
